import React, {Component} from 'react';

import {Link} from 'react-router-dom'

export default class AppLink extends Component {

    onClick = () => {
        // const host = 'app://'+location.hostname+(location.port ? ':'+location.port: '');
        // console.log(host + this.props.to);
        // sendObjectMessage(host + this.props.to);
    };

    render() {
        const {
            isApp
        } = this.props;
        return (
            <span>
                {isApp ?
                    <a href={this.props.to + "?app=1"}>{this.props.children}</a>
                    :
                    <Link onClick={this.onClick} to={this.props.to}>{this.props.children}</Link>
                }
            </span>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/AppLink.js